import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocalStorage } from '@uidotdev/usehooks';

export function useCookies() {
  const navigate = useNavigate();
  const [unidade] = useLocalStorage("sessionUnidade", null);

  function getUnidade() {
    
    if (unidade) return

    navigate("/", { replace: true })
  }

  React.useEffect(() => {
    getUnidade()
  }, []);

}
